import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { Ability, AbilityMarshaller } from 'app/constants/enums/Ability';
import { DateMarshaller } from 'app/constants/schemas/Date';

export interface IOauthApplication extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string;
    scopes: Ability[];
    redirectUri: string[];
    machineAccount: boolean;
    trusted: boolean;
    testEnvironment: boolean;
    confidential: boolean;
    durable: boolean;
    uid: string;
    secret?: string;
    staticallyConfigured: boolean;
    createdAt: Date;
    updatedAt: Date;
  };
}

export type OauthApplication = Entity<IOauthApplication>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OauthApplication: IEntityType<IOauthApplication> = vmClient.defineClass({
  typeName:    'Doorkeeper.Application',
  storePrefix: 'OauthApplication',
  version:     5,
  persisted:   true,
  attributes:  {
    name: {
      type:    'string',
      notNull: true,
    },
    scopes: {
      collection: true,
      type:       Ability,
      marshaller: AbilityMarshaller,
    },
    redirectUri: {
      collection: true,
      type:       'string',
      notNull:    true,
    },
    machineAccount: {
      type:    'boolean',
      notNull: true,
    },
    trusted: {
      type:    'boolean',
      notNull: true,
    },
    testEnvironment: {
      type:    'boolean',
      notNull: true,
    },
    confidential: {
      type:    'boolean',
      notNull: true,
    },
    durable: {
      type:    'boolean',
      notNull: true,
    },
    uid: {
      type:    'string',
      notNull: true,
    },
    secret: {
      notNull:   true,
      type:      'string',
      writeOnly: true,
    },
    staticallyConfigured: {
      type:    'boolean',
      notNull: true,
    },
    createdAt: {
      type:       Date,
      notNull:    true,
      marshaller: DateMarshaller,
    },
    updatedAt: {
      type:       Date,
      notNull:    true,
      marshaller: DateMarshaller,
    },
  },
});
